import { ComponentMap } from '@cinch-nx/data-storyblok'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import Video from '../video/video'
import {
  AuthorByline,
  CtaButton,
  FeatureCard,
  FeatureImageCard,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  TextInlineImage,
  TextInlineImageSection,
} from './blocks'
import { FaqAccordion } from '../faq-accordion/faq-accordion'

export const landingStoryblokComponents: ComponentMap = {
  ...globalStoryblokComponents,
  AuthorByline,
  CtaButton,
  FaqSection: FaqAccordion,
  FeatureCard,
  FeatureImageCard,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  LandingTextInlineImage: TextInlineImage,
  LandingTextInlineImageSection: TextInlineImageSection,
  YoutubeVideo: Video,
}
